import {
	CapitalLetterCondition,
	DifferentThanEmailCondition,
	DigitPresentCondition,
	MinimumLengthCondition,
	NoRepetitiveSequencesCondition,
	SmallLetterCondition,
	SpecialCharacterCondition
} from "./passwords-conditions";
import {Injectable} from "@angular/core";
import {PasswordValidator} from "./password-validator";
import {AsyncValidatorFn, ValidationErrors} from "@angular/forms";
import {first, map, mergeMap} from "rxjs/operators";
import {of} from "rxjs";
import {ConfigurationProvider} from "../../../configuration/configuration.provider";
import {EndpointsProvider} from "../../endpoints/endpoint-provider.service";

@Injectable()
export class PasswordValidatorFactory {

	constructor(private configProvider: ConfigurationProvider, private endpoints: EndpointsProvider) {
	}

	forClient(email: string): PasswordValidator {
		return new PasswordValidator([
			new SmallLetterCondition(),
			new CapitalLetterCondition(),
			new SpecialCharacterCondition(),
			new DigitPresentCondition(),
			new MinimumLengthCondition(8),
			new DifferentThanEmailCondition(email),
			new NoRepetitiveSequencesCondition()
		])
	}

	forDekraEmployee(email: string): PasswordValidator {
		return new PasswordValidator([
			new SmallLetterCondition(),
			new CapitalLetterCondition(),
			new SpecialCharacterCondition(),
			new DigitPresentCondition(),
			new MinimumLengthCondition(16),
			new DifferentThanEmailCondition(email),
			new NoRepetitiveSequencesCondition()
		])
	}

	compromisedPasswordsValidator(): AsyncValidatorFn {
		return control => {
			return control.value == null ?
				of(null) :
				this.configProvider.getConfiguration().pipe(
					first(),
					map(config => config.compromisedPasswordsFile),
					mergeMap(compromisedPasswordsFile => !!compromisedPasswordsFile ?
						this.endpoints.common.getCompromisedPasswords(compromisedPasswordsFile) :
						of("")
					),
					map((text: string) => {
						const isCompromised = text.split(/\r?\n/).some(compromisedPswd => compromisedPswd.toLowerCase() == control.value.toLowerCase())
						return isCompromised ? {"pswd-compromised": ""} as ValidationErrors : null;
					})
				);
		}
	}
}
